_ = require('lodash')
$ = require('jquery')
moment = require('moment')

IndexCtrl = ($scope, $rootScope, $location, HistoryService, $analytics, $routeParams, cache, userInfo) ->
  $analytics.eventTrack('HST_loaded')
  $scope.scorecards = []
  $scope.viewModel = undefined
  $scope.currentPage = 0
  $scope.isLoading = true
  $scope.noResults = false
  $scope.hideHeader = false
  $scope.cacheForUser = "history_page_state_for_user_#{$routeParams.user_id}"
  $scope.roundIdPositionCached = "round_id_position_cached_for_user_#{$routeParams.user_id}"
  $scope.userInfo = userInfo

  if $routeParams.hide_header == '1'
    $scope.hideHeader = true

  if cache.get($scope.cacheForUser)
    $rootScope.$watch (->
      $location.absUrl()
    ), ->
      # Clear cache history_cached_rounds_page
      currentPath = $location.absUrl()
      if currentPath.indexOf('/history') == -1 && currentPath.indexOf('/round-detail') == -1
        cache.remove($scope.cacheForUser)
        cache.remove($scope.roundIdPositionCached)

  angular.element(document).ready ->
    roundIdPositionCached = cache.get($scope.roundIdPositionCached)
    if roundIdPositionCached?
      $([ document.documentElement, document.body ]).animate { scrollTop: (parseInt(roundIdPositionCached) - 260) }, 200

  createViewModel = ->
    scorecards: HistoryService.convertToHistoryList($scope.scorecards)

  $scope.loadMore = (pageSize=10) ->
    $scope.isLoading = true
    cachedPage = cache.get($scope.cacheForUser)

    if cachedPage && $scope.currentPage == 0
      pageSize = pageSize * cachedPage
      $scope.currentPage++
    else if cachedPage && $scope.currentPage > 0
      $scope.currentPage += cachedPage
      cache.remove($scope.cacheForUser)
    else
      $scope.currentPage++

    params =
      page: $scope.currentPage
      page_size: pageSize
      user_id: $routeParams.user_id || userInfo.user_id
      round_type: $scope.roundType?.join(',') || $routeParams.round_type
      from: $scope.startDate || $routeParams.from
      to: $scope.endDate || $routeParams.to

    HistoryService.get(params)
      .then (resp) ->
        newScorecards = resp.data.score_cards.map (item) ->
          _.merge {}, item,
            yyyy: moment(item.play_date).format('YYYY')
            mmdd: moment(item.play_date).format('MM/DD')

        $scope.scorecards = _.union($scope.scorecards, newScorecards)
        $scope.scorecards = _.uniqBy($scope.scorecards, 'id')
        $scope.totalPages = resp.data.total_pages
        $scope.viewModel = createViewModel()
        $scope.noResults = $scope.scorecards.length is 0
      .finally ->
        $scope.isLoading = false

  $scope.showScoreCardDetail = (id) ->
    cachedPage = _.max([cache.get($scope.cacheForUser), $scope.currentPage])
    cache.put($scope.cacheForUser, cachedPage)
    cache.put($scope.roundIdPositionCached, $("##{id}").offset()?.top)
    $location.path('/round-detail/' + id)

  $scope.hasMore = ->
    $scope.currentPage isnt $scope.totalPages

  $scope.formatDate = (date) ->
    moment(date).format("YYYY/MM/DD")

  $scope.classForRoundIcons = (history) ->
    switch history.round_type
      when 1.5 then 'icons-extra9'
      when 0.5 then 'icons-half-nine'
      else ''

  $scope.$on "periodSelected.gnp.history", (event, startDate, endDate, roundType) ->
    $scope.currentPage = 0
    $scope.scorecards = []
    $scope.startDate = startDate?.clone()
    $scope.endDate = endDate?.clone()
    $scope.roundType = roundType
    $scope.loadMore()

  $scope.$on "roundTypeUpdated.gnp.history", (event, roundType) ->
    $scope.currentPage = 0
    $scope.scorecards = []
    $scope.roundType = roundType
    $scope.loadMore()

IndexCtrl.$inject = [
  '$scope'
  '$rootScope'
  '$location'
  'HistoryService'
  '$analytics'
  '$routeParams'
  'cache'
  'userInfo'
]

module.exports = IndexCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/history/index-controller.coffee